<div class="report-container">
  <!-- Unassigned Devices Warning Banner for Superadmins (AC-3) -->
  <div class="unassigned-warning-banner" *ngIf="isSuperAdmin && unassignedDevicesCount > 0">
    <span>⚠️ <strong>{{ unassignedDevicesCount }} device(s) have no brand assigned.</strong> These devices are excluded from brand-specific reports. Please run the <strong>Backfill Device brandId</strong> tool in Developer Tools to link them.</span>
  </div>

  <div class="header-section">
    <h2>Daily Machine Report</h2>
    <div class="month-label" *ngIf="!isDateRange">Report for {{ selectedDate | date:'MMMM yyyy' }}</div>
    <div class="month-label" *ngIf="isDateRange">Report for {{ selectedDate | date:'mediumDate' }} - {{ endDate | date:'mediumDate' }}</div>
  </div>

  <!-- Monthly KPIs (Hidden when Date Range is active) -->
  <ng-container *ngIf="!isDateRange">
    <div class="kpi-section-label">Monthly Totals</div>
    <div class="kpi-container">
      <div class="kpi-card">
        <label>Monthly Cash</label>
        <div class="value">{{ monthlyStats.cash | currency }}</div>
      </div>
      <div class="kpi-card">
        <label>Monthly Card</label>
        <div class="value">{{ monthlyStats.credit | currency }}</div>
      </div>
      <div class="kpi-card coupon-kpi">
        <label>Monthly Coupon</label>
        <div class="value coupon-val">{{ monthlyStats.coupon | currency }}</div>
        <div class="kpi-note">※ This value is not being added to revenue</div>
      </div>
      <div class="kpi-card">
        <label>Monthly Overcharge</label>
        <div class="value danger">{{ monthlyStats.overCharge | currency }}</div>
      </div>
      <div class="kpi-card highlight">
        <label>Monthly Grand Total</label>
        <div class="value">{{ monthlyStats.grandTotal | currency }}</div>
      </div>
    </div>
  </ng-container>

  <!-- Daily / Date Range KPIs -->
  <div class="kpi-section-label" *ngIf="!isDateRange">Daily Totals ({{ selectedDate | date:'mediumDate' }})</div>
  <div class="kpi-section-label" *ngIf="isDateRange">Date Range Totals ({{ selectedDate | date:'mediumDate' }} - {{ endDate | date:'mediumDate' }})</div>
  <div class="kpi-container daily-kpi">
    <div class="kpi-card">
      <label *ngIf="!isDateRange">Daily Cash</label>
      <label *ngIf="isDateRange">({{ selectedDate | date:'MM/dd/yy' }} - {{ endDate | date:'MM/dd/yy' }}) Cash</label>
      <div class="value">{{ dailyStats.cash | currency }}</div>
    </div>
    <div class="kpi-card">
      <label *ngIf="!isDateRange">Daily Card</label>
      <label *ngIf="isDateRange">({{ selectedDate | date:'MM/dd/yy' }} - {{ endDate | date:'MM/dd/yy' }}) Card</label>
      <div class="value">{{ dailyStats.credit | currency }}</div>
    </div>
    <div class="kpi-card coupon-kpi">
      <label *ngIf="!isDateRange">Daily Coupon</label>
      <label *ngIf="isDateRange">({{ selectedDate | date:'MM/dd/yy' }} - {{ endDate | date:'MM/dd/yy' }}) Coupon</label>
      <div class="value coupon-val">{{ dailyStats.coupon | currency }}</div>
      <div class="kpi-note">※ This value is not being added to revenue</div>
    </div>
    <div class="kpi-card">
      <label *ngIf="!isDateRange">Daily Overcharge</label>
      <label *ngIf="isDateRange">({{ selectedDate | date:'MM/dd/yy' }} - {{ endDate | date:'MM/dd/yy' }}) Overcharge</label>
      <div class="value danger">{{ dailyStats.overCharge | currency }}</div>
    </div>
    <div class="kpi-card highlight">
      <label *ngIf="!isDateRange">Daily Grand Total</label>
      <label *ngIf="isDateRange">({{ selectedDate | date:'MM/dd/yy' }} - {{ endDate | date:'MM/dd/yy' }}) Grand Total</label>
      <div class="value">{{ dailyStats.grandTotal | currency }}</div>
    </div>
  </div>

  <div class="filters">
    <div class="filter-group date-filter-container">
      <div class="date-controls-row">
        <!-- From Date / Single Date -->
        <div class="date-picker-item">
          <label>{{ isDateRange ? 'From Date' : 'Select Date' }}</label>
          <div class="date-picker-wrapper">
            <input matInput [matDatepicker]="picker" [(ngModel)]="selectedDate" (dateChange)="onDateChange()"
              class="date-input">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker [dateClass]="dateClass"></mat-datepicker>
          </div>
        </div>

        <!-- To Date Picker (Visible when Date Range is checked) -->
        <div class="date-picker-item" *ngIf="isDateRange">
          <label>To Date</label>
          <div class="date-picker-wrapper">
            <input matInput [matDatepicker]="pickerEnd" [(ngModel)]="endDate" (dateChange)="onEndDateChange()"
              class="date-input">
            <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
            <mat-datepicker #pickerEnd></mat-datepicker>
          </div>
        </div>

        <!-- Date Range Toggle Checkbox (On the right side) -->
        <div class="date-range-toggle">
          <input type="checkbox" id="dateRangeCheck" [checked]="isDateRange" (change)="toggleDateRange($event)" class="date-range-checkbox">
          <label for="dateRangeCheck" class="date-range-label">Date Range</label>
        </div>
      </div>
    </div>

    <div class="filter-group dropdowns-group">
      <div class="test-machines-toggle">
        <input type="checkbox" id="testMachinesCheck" [checked]="showTestMachines" (change)="toggleTestMachines()" class="test-machines-checkbox">
        <label for="testMachinesCheck" class="test-machines-label">Show Test Machines</label>
      </div>

      <div class="filter-dropdown" [class.dropdown-active]="showStoreFilterDropdown">
        <button class="action-btn utility-btn dropdown-trigger-btn" (click)="toggleStoreFilter()" [class.active]="showStoreFilterDropdown" [disabled]="allUniqueStores.length === 0 && !selectedBrand">
          <span>Select Stores ({{ selectedStores.size }}/{{ allUniqueStores.length }})</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" [class.rotated]="showStoreFilterDropdown"><polyline points="6 9 12 15 18 9"></polyline></svg>
        </button>
        <div class="dropdown-menu" *ngIf="showStoreFilterDropdown">
          <div class="dropdown-item search-item" (click)="$event.stopPropagation()">
            <input type="text" [(ngModel)]="storeFilterSearchText" placeholder="Search store..." class="dropdown-search-input">
          </div>
          <div class="dropdown-item" (click)="toggleAllStores()">
            <input type="checkbox" [checked]="isAllStoresSelected" (click)="$event.stopPropagation(); toggleAllStores()">
            <span>Select All</span>
          </div>
          <div class="dropdown-divider"></div>
          <div class="dropdown-scroll">
            <div class="dropdown-empty-state" *ngIf="getFilteredStores().length === 0">
              {{ allUniqueStores.length === 0 ? 'No stores found for the selected brand.' : 'No stores match your search.' }}
            </div>
            <div class="dropdown-item" *ngFor="let s of getFilteredStores()" (click)="toggleStoreSelection(s)">
              <input type="checkbox" [checked]="selectedStores.has(s)" (click)="$event.stopPropagation(); toggleStoreSelection(s)">
              <span>{{ s }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-dropdown" [class.dropdown-active]="showDeviceFilterDropdown">
        <button class="action-btn utility-btn dropdown-trigger-btn" (click)="toggleDeviceFilter()" [class.active]="showDeviceFilterDropdown" [disabled]="allUniqueDevices.length === 0">
          <span>Select Devices ({{ selectedDevices.size }}/{{ allUniqueDevices.length }})</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" [class.rotated]="showDeviceFilterDropdown"><polyline points="6 9 12 15 18 9"></polyline></svg>
        </button>
        <div class="dropdown-menu" *ngIf="showDeviceFilterDropdown">
          <div class="dropdown-item search-item" (click)="$event.stopPropagation()">
            <input type="text" [(ngModel)]="deviceFilterSearchText" placeholder="Search device..." class="dropdown-search-input">
          </div>
          <div class="dropdown-item" (click)="toggleAllDevices()">
            <input type="checkbox" [checked]="isAllDevicesSelected" (click)="$event.stopPropagation(); toggleAllDevices()">
            <span>Select All</span>
          </div>
          <div class="dropdown-divider"></div>
          <div class="dropdown-scroll">
            <div class="dropdown-item" *ngFor="let d of getFilteredDevices()" (click)="toggleDeviceSelection(d)">
              <input type="checkbox" [checked]="selectedDevices.has(d)" (click)="$event.stopPropagation(); toggleDeviceSelection(d)">
              <span>{{ d }}</span>
            </div>
          </div>
        </div>
      </div>

      <button class="action-btn" (click)="fetchReport(true)" [disabled]="isLoading">
        Refresh
      </button>
      <button class="action-btn save-btn" (click)="exportToExcel()" [disabled]="isLoading || filteredData.length === 0">
        📊 Export to Excel
      </button>
    </div>
  </div>

  <div class="table-container">
    <div class="loading-shade" *ngIf="isLoading">
      <div class="spinner"></div>
    </div>

    <!-- Daily Report Table -->
    <table class="data-grid">
      <thead>
        <tr>
          <th (click)="sortBy('storeId')">
            StoreID <span *ngIf="sortColumn === 'storeId'">{{sortDirection === 'asc' ? '▲' : '▼'}}</span>
          </th>
          <th (click)="sortBy('Country')">
            Country <span *ngIf="sortColumn === 'Country'">{{sortDirection === 'asc' ? '▲' : '▼'}}</span>
          </th>
          <th (click)="sortBy('deviceId')">
            Machine ID <span *ngIf="sortColumn === 'deviceId'">{{sortDirection === 'asc' ? '▲' : '▼'}}</span>
          </th>
          <th *ngIf="!isKonoboxBrand" (click)="sortBy('PrintsLeft')">
            Prints Left <span *ngIf="sortColumn === 'PrintsLeft'">{{sortDirection === 'asc' ? '▲' : '▼'}}</span>
          </th>
          <th (click)="sortBy('StoreTotal')">
            Store Total <span *ngIf="sortColumn === 'StoreTotal'">{{sortDirection === 'asc' ? '▲' : '▼'}}</span>
          </th>
          <th (click)="sortBy('DailyRevenue')">
            {{ isDateRange ? 'Revenue' : 'Daily Revenue' }} <span *ngIf="sortColumn === 'DailyRevenue'">{{sortDirection === 'asc' ? '▲' : '▼'}}</span>
          </th>
          <th (click)="sortBy('CardTotal')">
            Card Total <span *ngIf="sortColumn === 'CardTotal'">{{sortDirection === 'asc' ? '▲' : '▼'}}</span>
          </th>
          <th (click)="sortBy('CashTotal')">
            Cash Total <span *ngIf="sortColumn === 'CashTotal'">{{sortDirection === 'asc' ? '▲' : '▼'}}</span>
          </th>
          <th (click)="sortBy('CouponTotal')">
            Coupon <span *ngIf="sortColumn === 'CouponTotal'">{{sortDirection === 'asc' ? '▲' : '▼'}}</span>
          </th>
          <th (click)="sortBy('DailyOverpaidAmount')">
            Overpaid Amount <span *ngIf="sortColumn === 'DailyOverpaidAmount'">{{sortDirection === 'asc' ? '▲' : '▼'}}</span>
          </th>
          <th (click)="sortBy('DailySessions')">
            {{ isDateRange ? 'Sessions' : 'Daily Sessions' }} <span *ngIf="sortColumn === 'DailySessions'">{{sortDirection === 'asc' ? '▲' : '▼'}}</span>
          </th>
          <th *ngIf="!isDateRange" class="actions-header-cell">
            Actions
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let element of filteredData; let i = index">
          <tr class="element-row" [class.first-rows]="i < 2" (click)="selectRow(element)" [class.selected]="selectedRow === element">
            <td>{{element.storeId}}</td>
            <td>{{element.Country}}</td>
            <td class="device-id-cell">
              <div class="tooltip-wrapper" [class.tooltip-down]="i < 2" [class.active]="activeTooltipDeviceId === element.deviceId" (click)="toggleTooltip(element.deviceId, $event)">
                <span class="device-name-text">{{element.deviceId}}</span>
                <span class="overridden-badge" *ngIf="!isDateRange && element.isMonthlyOverridden" title="This machine has overridden revenue records in this month">Overridden</span>
                <div class="custom-tooltip">
                  <div class="tooltip-header">Device Status</div>
                  <div class="status-row">
                    <span class="status-label">Device Online</span>
                    <div class="status-indicator" [class.connected]="element.deviceOnline" [class.offline]="!element.deviceOnline"></div>
                  </div>
                  <div class="status-row" *ngIf="!isKonoboxBrand">
                    <span class="status-label">Camera Status</span>
                    <div class="status-indicator" [class.connected]="element.deviceOnline && element.cameraConnected" [class.offline]="!element.deviceOnline || !element.cameraConnected"></div>
                  </div>
                  <div class="status-row">
                    <span class="status-label">Card Machine</span>
                    <div class="status-indicator" [class.connected]="element.deviceOnline && element.cardMachineConnected" [class.offline]="!element.deviceOnline || !element.cardMachineConnected"></div>
                  </div>
                  <div class="status-row">
                    <span class="status-label">Bill Acceptor</span>
                    <div class="status-indicator" [class.connected]="element.deviceOnline && element.billAcceptorConnected" [class.offline]="!element.deviceOnline || !element.billAcceptorConnected"></div>
                  </div>
                </div>
              </div>
            </td>
            <td *ngIf="!isKonoboxBrand">{{element.PrintsLeft | number}}</td>
            <td class="store-total-cell">{{element.StoreTotal | currency}}</td>
            <td class="daily-revenue-cell">
              <ng-container *ngIf="!isDateRange && element.isDailyOverridden">
                <a href="javascript:void(0)" class="overridden-number-link" (click)="openOverrideDetailsModal(element, $event)" title="Click to view override audit details">
                  {{element.DailyRevenue | currency}}
                </a>
              </ng-container>
              <ng-container *ngIf="isDateRange || !element.isDailyOverridden">
                {{element.DailyRevenue | currency}}
              </ng-container>
            </td>
            <td>
              <ng-container *ngIf="!isDateRange && element.isDailyOverridden">
                <a href="javascript:void(0)" class="overridden-number-link" (click)="openOverrideDetailsModal(element, $event)" title="Click to view override audit details">
                  {{element.CardTotal | currency}}
                </a>
              </ng-container>
              <ng-container *ngIf="isDateRange || !element.isDailyOverridden">
                {{element.CardTotal | currency}}
              </ng-container>
            </td>
            <td>
              <ng-container *ngIf="!isDateRange && element.isDailyOverridden">
                <a href="javascript:void(0)" class="overridden-number-link" (click)="openOverrideDetailsModal(element, $event)" title="Click to view override audit details">
                  {{element.CashTotal | currency}}
                </a>
              </ng-container>
              <ng-container *ngIf="isDateRange || !element.isDailyOverridden">
                {{element.CashTotal | currency}}
              </ng-container>
            </td>
            <td>{{(element.CouponTotal || 0) | currency}}</td>
            <td class="overpaid-amount-cell">{{(element.DailyOverpaidAmount || 0) | currency}}</td>
            <td>{{element.DailySessions | number}}</td>
            <td *ngIf="!isDateRange" class="actions-cell" (click)="$event.stopPropagation()">
              <button class="modify-btn" (click)="openOverrideModal(element, $event)" title="Modify daily revenue numbers">
                ✏️ Modify
              </button>
            </td>
          </tr>
          <!-- Expandable Detail Row -->
          <tr *ngIf="selectedRow === element" class="detail-row">
            <td [attr.colspan]="isDateRange ? (isKonoboxBrand ? 10 : 11) : (isKonoboxBrand ? 11 : 12)">
              <div class="detail-content">
                <div class="detail-item">
                  <span class="detail-label">Daily Sessions</span>
                  <div class="detail-value">
                    <a href="javascript:void(0)" (click)="openSessionDetails(element); $event.stopPropagation()" class="session-count-link">
                      {{element.DailySessions | number}}
                    </a>
                  </div>
                </div>
                <div class="detail-item" *ngIf="!isKonoboxBrand">
                  <span class="detail-label">Animefied Generated</span>
                  <div class="detail-value">{{element.DailyAnimefiedGenerated | number}}</div>
                </div>
                <div class="detail-item" *ngIf="!isKonoboxBrand">
                  <span class="detail-label">Animefied Used</span>
                  <div class="detail-value">{{element.DailyAnimefiedUsed | number}}</div>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="filteredData.length === 0 && !isLoading">
          <td [attr.colspan]="isDateRange ? (isKonoboxBrand ? 10 : 11) : (isKonoboxBrand ? 11 : 12)" class="empty-row-cell">No data found.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Modify Daily Revenue Modal -->
  <div class="modal-overlay" *ngIf="isOverrideModalOpen" (click)="closeOverrideModal()">
    <div class="modal-content override-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div class="header-title-wrapper">
          <h2>✏️ Modify Daily Numbers</h2>
          <span class="device-badge" *ngIf="overrideTargetRow">{{ overrideTargetRow.deviceId }}</span>
        </div>
        <button class="close-btn" (click)="closeOverrideModal()">&times;</button>
      </div>

      <div class="modal-body" *ngIf="overrideTargetRow">
        <div class="override-info-banner">
          <div class="info-item">
            <span class="info-label">Date:</span>
            <span class="info-val">{{ selectedDate | date:'MMMM d, yyyy' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Store:</span>
            <span class="info-val">{{ overrideTargetRow.storeId }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Country:</span>
            <span class="info-val">{{ overrideTargetRow.Country || '-' }}</span>
          </div>
        </div>

        <div class="override-warning-box">
          ⚠️ Modifying these values will override the recorded financial metrics for this day and automatically update the monthly totals in Firebase database.
        </div>

        <div class="override-form-grid">
          <div class="form-group">
            <label class="form-label" for="overrideCard">Card Total ($)</label>
            <div class="input-prefix-wrapper">
              <span class="prefix">$</span>
              <input type="number" id="overrideCard" [(ngModel)]="overrideCardTotal" class="form-input" step="0.01" min="0" placeholder="0.00">
            </div>
          </div>

          <div class="form-group">
            <label class="form-label" for="overrideCash">Cash Total ($)</label>
            <div class="input-prefix-wrapper">
              <span class="prefix">$</span>
              <input type="number" id="overrideCash" [(ngModel)]="overrideCashTotal" class="form-input" step="0.01" min="0" placeholder="0.00">
            </div>
          </div>

          <div class="form-group">
            <label class="form-label" for="overrideSessions">Daily Sessions</label>
            <div class="input-prefix-wrapper">
              <span class="prefix">#</span>
              <input type="number" id="overrideSessions" [(ngModel)]="overrideSessions" class="form-input" step="1" min="0" placeholder="0">
            </div>
          </div>

          <div class="form-group summary-group">
            <label class="form-label">Calculated Daily Revenue</label>
            <div class="calculated-rev-val">
              {{ (overrideCardTotal + overrideCashTotal) | currency }}
            </div>
          </div>

          <div class="form-group full-width">
            <label class="form-label" for="overrideReason">
              Override Reason <span class="required-star">*</span>
            </label>
            <textarea 
              id="overrideReason" 
              [(ngModel)]="overrideReasonInput" 
              placeholder="Enter mandatory reason for modifying these numbers..." 
              class="form-textarea" 
              rows="2"
              required>
            </textarea>
            <span class="field-hint" *ngIf="!overrideReasonInput || !overrideReasonInput.trim()">
              ※ Reason is required to save changes.
            </span>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeOverrideModal()" [disabled]="isSavingOverride">
          Cancel
        </button>
        <button class="btn btn-primary" (click)="saveOverrideNumbers()" [disabled]="isSavingOverride || !overrideReasonInput || !overrideReasonInput.trim()">
          <span class="btn-spinner" *ngIf="isSavingOverride"></span>
          {{ isSavingOverride ? 'Saving to Database...' : 'Save Changes' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Override Audit Details Modal -->
  <div class="modal-overlay" *ngIf="isOverrideDetailsModalOpen" (click)="closeOverrideDetailsModal()">
    <div class="modal-content override-details-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div class="header-title-wrapper">
          <h2>📋 Override Details & Audit Log</h2>
          <span class="device-badge" *ngIf="overrideDetailsRow">{{ overrideDetailsRow.deviceId }}</span>
        </div>
        <button class="close-btn" (click)="closeOverrideDetailsModal()">&times;</button>
      </div>

      <div class="modal-body" *ngIf="overrideDetailsRow">
        <div class="override-info-banner">
          <div class="info-item">
            <span class="info-label">Date:</span>
            <span class="info-val">{{ selectedDate | date:'MMMM d, yyyy' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Store:</span>
            <span class="info-val">{{ overrideDetailsRow.storeId }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Country:</span>
            <span class="info-val">{{ overrideDetailsRow.Country || '-' }}</span>
          </div>
        </div>

        <!-- Comparison Table: Original vs Overridden Numbers -->
        <div class="comparison-section">
          <h3 class="section-subtitle">Financial Numbers Comparison</h3>
          <table class="comparison-table">
            <thead>
              <tr>
                <th>Metric</th>
                <th>Original Number</th>
                <th>Overridden (Current)</th>
                <th>Difference</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Card Total</td>
                <td class="orig-num">{{ (overrideDetailsRow.originalValues?.CardTotal ?? 0) | currency }}</td>
                <td class="new-num highlight-yellow">{{ overrideDetailsRow.CardTotal | currency }}</td>
                <td class="diff-num" [class.diff-pos]="overrideDetailsRow.CardTotal >= (overrideDetailsRow.originalValues?.CardTotal ?? 0)">
                  {{ (overrideDetailsRow.CardTotal - (overrideDetailsRow.originalValues?.CardTotal ?? 0)) | currency }}
                </td>
              </tr>
              <tr>
                <td>Cash Total</td>
                <td class="orig-num">{{ (overrideDetailsRow.originalValues?.CashTotal ?? 0) | currency }}</td>
                <td class="new-num highlight-yellow">{{ overrideDetailsRow.CashTotal | currency }}</td>
                <td class="diff-num" [class.diff-pos]="overrideDetailsRow.CashTotal >= (overrideDetailsRow.originalValues?.CashTotal ?? 0)">
                  {{ (overrideDetailsRow.CashTotal - (overrideDetailsRow.originalValues?.CashTotal ?? 0)) | currency }}
                </td>
              </tr>
              <tr class="total-row">
                <td>Daily Revenue</td>
                <td class="orig-num">{{ (overrideDetailsRow.originalValues?.DailyRevenue ?? 0) | currency }}</td>
                <td class="new-num highlight-yellow">{{ overrideDetailsRow.DailyRevenue | currency }}</td>
                <td class="diff-num" [class.diff-pos]="overrideDetailsRow.DailyRevenue >= (overrideDetailsRow.originalValues?.DailyRevenue ?? 0)">
                  {{ (overrideDetailsRow.DailyRevenue - (overrideDetailsRow.originalValues?.DailyRevenue ?? 0)) | currency }}
                </td>
              </tr>
              <tr>
                <td>Daily Sessions</td>
                <td class="orig-num">{{ (overrideDetailsRow.originalValues?.DailySessions ?? 0) | number }}</td>
                <td class="new-num highlight-yellow">{{ overrideDetailsRow.DailySessions | number }}</td>
                <td class="diff-num">
                  {{ (overrideDetailsRow.DailySessions - (overrideDetailsRow.originalValues?.DailySessions ?? 0)) | number }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Audit Metadata -->
        <div class="audit-meta-card">
          <div class="audit-meta-item">
            <span class="audit-meta-label">Override Reason:</span>
            <div class="audit-reason-text">{{ overrideDetailsRow.overrideReason || 'No reason recorded' }}</div>
          </div>
          <div class="audit-meta-grid">
            <div class="audit-meta-item">
              <span class="audit-meta-label">Updated By:</span>
              <span class="audit-meta-val">{{ overrideDetailsRow.updatedBy || 'Unknown User' }}</span>
            </div>
            <div class="audit-meta-item">
              <span class="audit-meta-label">Updated Date:</span>
              <span class="audit-meta-val">{{ (overrideDetailsRow.updatedAt?.toDate ? overrideDetailsRow.updatedAt.toDate() : overrideDetailsRow.updatedAt) | date:'medium' }}</span>
            </div>
          </div>
        </div>

        <!-- Historical Edit Log if available -->
        <div class="history-section" *ngIf="overrideDetailsRow.overrideHistory && overrideDetailsRow.overrideHistory.length > 1">
          <h3 class="section-subtitle">Revision History</h3>
          <div class="history-timeline">
            <div class="history-entry" *ngFor="let h of overrideDetailsRow.overrideHistory; let idx = index">
              <div class="history-badge">#{{ idx + 1 }}</div>
              <div class="history-body">
                <div class="history-header">
                  <strong>{{ h.updatedBy }}</strong> modified on 
                  <span>{{ (h.updatedAt?.toDate ? h.updatedAt.toDate() : h.updatedAt) | date:'short' }}</span>
                </div>
                <div class="history-reason">"{{ h.overrideReason }}"</div>
                <div class="history-values">
                  Card: {{ h.previousCard | currency }} ➔ <strong>{{ h.newCard | currency }}</strong> | 
                  Cash: {{ h.previousCash | currency }} ➔ <strong>{{ h.newCash | currency }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeOverrideDetailsModal()">
          Close
        </button>
        <button class="btn btn-primary" *ngIf="overrideDetailsRow" (click)="openOverrideModal(overrideDetailsRow); closeOverrideDetailsModal()">
          ✏️ Edit Numbers Again
        </button>
      </div>
    </div>
  </div>
</div>